import { render, staticRenderFns } from "./VisitorPropertiesView.vue?vue&type=template&id=2ba2c9fe"
import script from "./VisitorPropertiesView.vue?vue&type=script&lang=js"
export * from "./VisitorPropertiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports